import $ from 'jquery';
import config from './../../config';
const URL_API = config.urlApi+'controlador/inventario_productos/getProductoUnidadByUnidad.php';

export default function getProductoUnidadByUnidad({values}){
    return $.ajax({
        url: URL_API,
        type: 'POST',
        data: values
    })
}